import {
    type LotteryCommunicationItem,
    type TileListItem,
    isProductItem,
} from '@tilelist/domain/composition/TileListitem.ts';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';

export const LOTTERY_COMMUNICATION_POSITION = 6;

/**
 *
 */
export const SELECTED_LOTTERY_RULES: readonly string[] = [
    /*         */
    '(und.(ist.aktion.shoppen-und-gewinnen.shoppen-und-gewinnenplus).(ist.reduziert).(~.(v.1)))',
    /*                */
    '(und.(ist.aktion.shoppen-und-gewinnenplus).(ist.reduziert).(~.(v.1)))',
    /*      */
    '(und.(ist.aktion.shoppen-und-gewinnen.shoppen-und-gewinnenplus).(ist.reduziert).(ist.sortiment.buerotechnik.haushaltsgeraete.kommunikation.medien.navigation.optik.reinigungsgeraete.schreibwaren.technik-zubehoer.unterhaltungselektronik).(~.(v.1)))',
    /*       */
    '(und.(ist.aktion.shoppen-und-gewinnen.shoppen-und-gewinnenplus).(oder.(ist.sortiment.arbeitsschutzkleidung.bauelemente.baumaschinen.baumaterialien.bewaesserung.bodenbelaege.eisenwaren.elektroinstallation.farben-lacke.gartengeraete.gartengestaltung.gebaeude.heizen.insektenschutz.klima.pflanzenpflege.pools.sanitaer.sicherheitstechnik.sonnenschutz.tierbedarf.werkzeug).(und.(ist.raum.garten).(ist.sortiment.moebel)).(und.(ist.sortiment.reinigungsgeraete).(oder.(sind.kategorien.besen).(sind.kategorien.dampfreiniger).(sind.kategorien.felgenbuersten).(sind.kategorien.hochdruckreiniger).(sind.kategorien.kehrmaschinen).(sind.kategorien.sauger.dampfsauger).(sind.kategorien.sauger.industriesauger).(sind.kategorien.sauger.nass-trockensauger).(sind.kategorien.wischer)))).(~.(v.1)))',
    /*                */
    '(und.(ist.aktion.shoppen-und-gewinnen.shoppen-und-gewinnenplus).(ist.reduziert).(ist.sortiment.erotik.gesichtspflege.gesundheitsprodukte.haarentfernung.haarpflege.haarstyling.hautpflege.make-up.parfums.zahnpflege).(~.(v.1)))',
    /*    */
    '(und.(ist.aktion.shoppen-und-gewinnen.shoppen-und-gewinnenplus).(ist.reduziert).(ist.sortiment.accessoires.fahrzeuge.fahrzeugeausruestung.gesundheitsprodukte.navigation.optik.sportausruestung.unterhaltungselektronik).(oder.(ist.sportart.american-football.badminton.baseball.basketball.beachvolleyball.boxen.darts.eishockey.eiskunstlauf.eislaufen.fussball.golf.handball.hockey.kampfsport.karate.kick-boxing.kitesurfen.klettern.reiten.rugby.skateboarding.ski.skilanglauf.snowboard.softball.squash.stand-up-paddling.taekwondo.tennis.tischtennis.volleyball.wakeboarden.wasserball.windsurfen.yoga).(sind.kategorien.boards).(sind.kategorien.fahrradcomputer).(sind.kategorien.fitness-tracker).(sind.kategorien.kameras.action-cams).(sind.kategorien.pulsgurte).(sind.kategorien.schlaeger).(sind.kategorien.schlittschuhe).(sind.kategorien.scooter).(sind.kategorien.skates).(sind.kategorien.spieltische).(sind.kategorien.trainer.ems).(sind.kategorien.uhren.pulsuhren)).(~.(v.1)))',
    /*        */
    '(und.(ist.aktion.shoppen-und-gewinnen.shoppen-und-gewinnenplus).(ist.reduziert).(ist.sortiment.basteln.musizieren.spielzeug.verkleidung).(~.(v.1)))',
];

function createLotteryCommunicationItem(): LotteryCommunicationItem {
    return { type: 'LotteryCommunication' };
}

export function isLotteryCommunicationItem(item?: TileListItem): boolean {
    return item?.type === 'LotteryCommunication';
}

/*                                                                                   */
function findInsertIndexAfterNthProduct(items: TileListItem[], n: number): number | undefined {
    let productCount = 0;
    const nthProductIndex = items.findIndex((item) => {
        if (isProductItem(item)) productCount++;
        return productCount === n;
    });

    return nthProductIndex >= 0 ? nthProductIndex + 1 : undefined;
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function insertLotteryCommunication(tileListItems: TileListItem[], rule?: string, onex?: OnEx): TileListItem[] {
    if (onex?.isToggleActive('EMERGENCY_DISABLE_LOTTERY_COMMUNICATION')) {
        return tileListItems;
    }

    if (!rule || !SELECTED_LOTTERY_RULES.includes(rule)) {
        return tileListItems;
    }

    const insertIndex = findInsertIndexAfterNthProduct(tileListItems, LOTTERY_COMMUNICATION_POSITION);
    if (insertIndex === undefined) {
        return tileListItems;
    }

    return [
        ...tileListItems.slice(0, insertIndex),
        createLotteryCommunicationItem(),
        ...tileListItems.slice(insertIndex),
    ];
}
